// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import "./Tab.css";
import * as microsoftTeams from "@microsoft/teams-js";
import AuthService from "../../session/AuthService";
import HomeTag from "./HomeTag";
import * as APPCONFIG from "../../config/app-config.js";
/**
 * This tab component renders the main tab content
 * of your app.
 */
class Tab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      login_value: 0,
      context: {},
      ssoToken: "",
      consentRequired: false,
      consentProvided: false,
      graphAccessToken: "",
      status: "Authorization Processing...",
      ServiceAccessToken: "",
      photo: "",
      error: false,
      meeting: false,
      meeting_name: "",
      meeting_start_date: "",
      meeting_end_date: "",
      user_to_meet: "",
      userData: "",
      event: false,
      meetingUrl: "",
      calendarData: "",
      user: {},
      page: 0,
      login: false,
    };

    //Bind any functions that need to be passed as callbacks or used to React components
    this.loadHome = this.loadHome.bind(this);
    this.loadLogin = this.loadLogin.bind(this);
    this.ssoLoginSuccess = this.ssoLoginSuccess.bind(this);
    this.ssoLoginFailure = this.ssoLoginFailure.bind(this);
    this.consentSuccess = this.consentSuccess.bind(this);
    this.callUser = this.callUser.bind(this);
    this.createTeamEvent = this.createTeamEvent.bind(this);
    this.consentFailure = this.consentFailure.bind(this);
    this.unhandledFetchError = this.unhandledFetchError.bind(this);
    this.callGraphFromClient = this.callGraphFromClient.bind(this);
    this.showConsentDialog = this.showConsentDialog.bind(this);
  }

  //React lifecycle method that gets called once a component has finished mounting
  //Learn more: https://reactjs.org/docs/react-component.html#componentdidmount
  componentDidMount() {
    // Initialize the Microsoft Teams SDK
    //alert("Started to Work");
    microsoftTeams.initialize();

    // Get the user context from Teams and set it in the state
    microsoftTeams.getContext((context, error) => {
      console.log(context);
      //alert("Wow, Login");
      let email = context["upn"];
      AuthService.setMSEmail(email.toLowerCase());
      AuthService.setMSUserInfo(context);
      AuthService.setMSTeamsApp();
      //alert(email);
      //alert("Set Session :" + AuthService.getMSEmail());
      this.setState({ context: context, login_value: 0 });
      console.log("User Values => context");
      console.log(context);
      this.props.history.push(`/mslogin`);
    });

    /*
    //Perform Azure AD single sign-on authentication
    let authTokenRequestOptions = {
      successCallback: (result) => { this.ssoLoginSuccess(result) }, //The result variable is the SSO token.
      failureCallback: (error) => { 
        console.log("Request Result : authTokenRequestOptions")
        console.log(error)
        this.ssoLoginFailure(error) 
      }
    };

    console.log("Logging in");

    microsoftTeams.authentication.getAuthToken(authTokenRequestOptions);
    */
  }

  ssoLoginSuccess = async (result) => {
    console.log("SSO SUCCESS");
    this.setState({ ssoToken: result });
    this.exchangeClientTokenForServiceAccount(result);
    this.exchangeClientTokenForServerToken(result);
  };

  ssoLoginFailure(error) {
    console.log("SSO FAILURE");
    console.error("SSO failed: ", error);
    this.setState({ error: true });
  }

  //Exchange the SSO access token for a Graph access token
  //Learn more: https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-on-behalf-of-flow
  exchangeClientTokenForServerToken = async (token) => {
    //let serverURL = `https://api.betalearnings.com/getGraphAccessToken?ssoToken=${token}`;
    let serverURL = `${APPCONFIG.TEAMS_SSO_URL}getGraphAccessToken?ssoToken=${token}`;
    console.log(`SERVER URL ${serverURL}`);
    let response = await fetch(serverURL).catch(this.unhandledFetchError); //This calls getGraphAccessToken route in /api-server/app.js
    let data = await response.json().catch(this.unhandledFetchError);
    console.log(data);
    console.log(response);
    if (!response.ok && data.error === "consent_required") {
      //A consent_required error means it's the first time a user is logging into to the app, so they must consent to sharing their Graph data with the app.
      //They may also see this error if MFA is required.
      this.setState({ consentRequired: true }); //This displays the consent required message.
      this.showConsentDialog(); //Proceed to show the consent dialogue.
    } else if (!response.ok) {
      //Unknown error
      console.error(data);
      this.setState({ error: true });
    } else {
      console.log(data);
      //Server side token exchange worked. Save the access_token to state, so that it can be picked up and used by the componentDidMount lifecycle method.
      let token = data["access_token"];
      AuthService.setMSGraphToken(token);
      this.setState({ graphAccessToken: token });
    }

    var nv = this.state.login_value + 1;
    this.setState({ login_value: nv }, () => {
      //alert("New Value " + nv + ", Service Account : " + this.state.login_value);
      this.loadLogin();
    });
  };

  exchangeClientTokenForServiceAccount = async (token) => {
    let serverURL = `${APPCONFIG.TEAMS_SSO_URL}getServiceAccessAccount?ssoToken=${token}`;
    console.log(`SERVER URL ${serverURL}`);
    let response = await fetch(serverURL).catch(this.unhandledFetchError); //This calls getGraphAccessToken route in /api-server/app.js
    let data = await response.json().catch(this.unhandledFetchError);
    console.log(data);
    console.log(response);
    if (!response.ok && data.error === "consent_required") {
      //A consent_required error means it's the first time a user is logging into to the app, so they must consent to sharing their Graph data with the app.
      //They may also see this error if MFA is required.
      this.setState({ consentRequired: true }); //This displays the consent required message.
      this.showConsentDialog(); //Proceed to show the consent dialogue.
    } else if (!response.ok) {
      //Unknown error
      console.error(data);
      this.setState({ error: true });
    } else {
      console.log(data);
      //Server side token exchange worked. Save the access_token to state, so that it can be picked up and used by the componentDidMount lifecycle method.
      let token = data["access_token"];
      AuthService.setMSServiceToken(token);
      this.setState({ ServiceAccessToken: data["access_token"] });
    }

    var nv = this.state.login_value + 1;
    this.setState({ login_value: nv }, () => {
      //alert("New Value " + nv + ", Service Account : " + this.state.login_value);
      this.loadLogin();
    });
  };

  //Show a popup dialogue prompting the user to consent to the required API permissions. This opens ConsentPopup.js.
  //Learn more: https://docs.microsoft.com/en-us/microsoftteams/platform/tabs/how-to/authentication/auth-tab-aad#initiate-authentication-flow
  showConsentDialog() {
    microsoftTeams.authentication.authenticate({
      url: window.location.origin + "/auth-start",
      width: 600,
      height: 535,
      successCallback: (result) => {
        this.consentSuccess(result);
      },
      failureCallback: (reason) => {
        this.consentFailure(reason);
      },
    });
  }

  //Callback function for a successful authorization
  consentSuccess(result) {
    console.log(result);
    //Save the Graph access token in state
    this.setState({
      graphAccessToken: result,
      consentProvided: true,
    });
  }

  consentFailure(reason) {
    console.error("Consent failed: ", reason);
    this.setState({ error: true });
  }

  //React lifecycle method that gets called after a component's state or props updates
  //Learn more: https://reactjs.org/docs/react-component.html#componentdidupdate
  componentDidUpdate = async (prevProps, prevState) => {
    //Check to see if a Graph access token is now in state AND that it didn't exist previously
    if (
      prevState.graphAccessToken === "" &&
      this.state.graphAccessToken !== ""
    ) {
      //this.callGraphFromClient();
    }
  };

  // Fetch the user's profile photo from Graph using the access token retrieved either from the server
  // or microsoftTeams.authentication.authenticate
  callGraphFromClient = async () => {
    
    let graphPhotoEndpoint = `https://graph.microsoft.com/v1.0/me/photo/$value`;

    let graphRequestParams = {
      method: "GET",
      headers: {
        "Content-Type": "image/jpg",
        authorization: "bearer " + this.state.graphAccessToken,
      },
    };

    let response = await fetch(graphPhotoEndpoint, graphRequestParams).catch(
      this.unhandledFetchError
    );

    if (!response.ok) {
      console.error("ERROR: ", response);
      this.setState({ error: true });
    }

    let imageBlog = await response.blob().catch(this.unhandledFetchError); //Get image data as raw binary data

    this.setState({
      photo: URL.createObjectURL(imageBlog), //Convert binary data to an image URL and set the url in state
      login: true,
    });
  };

  //Generic error handler ( avoids having to do async fetch in try/catch block )
  unhandledFetchError(err) {
    console.error("Unhandled fetch error: ", err);
    this.setState({ error: true });
  }

  loadHome = async () => {
    this.setState({
      page: 0,
    });
  };

  loadLogin = async () => {
    //alert("Count Is :" + this.state.login_value);
    if (this.state.login_value === 2) {
      //this.callGraphFromClient();
      this.getUsers();
      //this.props.history.push(`/mslogin`)
    }
  };

  getUsers = async () => {
    this.setState({
      status: "Loading Teams Information",
      page: 0,
    });

    
    let graphPhotoEndpoint = `https://graph.microsoft.com/v1.0/users`;
    let graphRequestParams = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "bearer " + this.state.ServiceAccessToken,
      },
    };

    let response = await fetch(graphPhotoEndpoint, graphRequestParams).catch(
      this.unhandledFetchError
    );
    let data = await response.json().catch(this.unhandledFetchError);

    let users = data["value"];
    this.setState({
      userData: users,
      page: 0,
    });

    AuthService.setMSUsersData(users);
    console.log("-----------");
    console.log(users);
    console.log("-----------");
    console.log(data);

    let userMSData = users;
    let msemail = AuthService.getMSEmail();
    console.log("-----------");
    console.log(msemail);

    console.log("Chekcing Email :" + msemail);
    //alert("Count Start");
    for (var i = 0; i < userMSData.length; i++) {
      var obj = userMSData[i];

      //console.log(profileValue.user.email)
      //console.log(obj);

      let mail = obj.mail;
      if (obj.mail) {
        mail = obj.mail.toLowerCase();
      } else if (obj.userPrincipalName) {
        mail = obj.userPrincipalName.toLowerCase();
      }

      console.log(mail);

      if (mail === msemail.toLowerCase()) {
        let userid = obj.id;
        //alert("Traced");
        AuthService.setMSUserInfo(obj);

        //let userInfo = AuthService.getMSUserInfo();
        //console.log("User Info:");
        //console.log(userInfo);
        this.setState({
          user_meet: obj,
          user_meet_id: userid,
        });
        //console.log("Traced : Object");
        //console.log(obj);
        //alert("Success");
      }
    }

    this.props.history.push(`/mslogin`);
    console.log(data["value"]);
    console.log(response);
  };

  callthisUser = async (user) => {
    console.log("calling this user" + user.id);
    let upn = this.state.context["upn"];
    this.setState({
      user_to_meet: user.id,
    });

    let callendpoint = `https://graph.microsoft.com/v1.0/users/${upn}/messages`;

    const jsonBody = {
      subject: "Hello world",
      importance: "Low",
      body: {
        contentType: "HTML",
        content: "hello world",
      },
      toRecipients: [
        {
          emailAddress: {
            address: "AdeleV@betalearnings.onmicrosoft.com",
          },
        },
      ],
    };

    let reqParams = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "bearer " + this.state.ServiceAccessToken,
      },
      body: JSON.stringify(jsonBody),
    };

    let callresponse = await fetch(callendpoint, reqParams).catch(
      this.unhandledFetchError
    );
    let calldata = await callresponse.json().catch(this.unhandledFetchError);

    console.log(callresponse);
    console.log(calldata);
  };

  MeetThisUser = async (user) => {
    console.log("meet this user" + user.id);
    this.setState({
      meeting: true,
      event: false,
      user_to_meet: user.id,
    });
  };

  onMeetingNameChange(value) {
    this.setState({
      meeting_name: value,
    });
  }

  onMeetingStartDate(value) {
    this.setState({
      meeting_start_date: value,
    });
  }

  onMeetingendDate(value) {
    this.setState({
      meeting_end_date: value,
    });
  }

  callUser = async (user) => {
    console.log("Call User");
    console.log(user);
    let mail = user.mail;
    var name = user.displayName;
    name = name.split(" ").join("-");
    //microsoftTeams.executeDeepLink("https://teams.microsoft.com/l/chat/0/0?users=joe@contoso.com,bob@contoso.com&topicName=Prep%20For%20Meeting%20Tomorrow&message=Hi%20folks%2C%20kicking%20off%20a%20chat%20about%20our%20meeting%20tomorrow");
    let link =
      "https://teams.microsoft.com/l/chat/0/0?users=" +
      mail +
      "&topicName=Prep%20For%20Meeting%20Tomorrow&message=Hi%" +
      name +
      "%2C%20kicking%20off%20a%20chat%20about%20our%20meeting%now";
    console.log(link);
    microsoftTeams.executeDeepLink(link);
    //alert(mail)
  };

  createMeeting = async () => {
    console.log(this.state.user.id);

    var name = this.state.user.displayName;
    name = name.split(" ").join("-");
    //let graphEndpoint = `https://graph.microsoft.com/v1.0/me/onlineMeetings/createOrGet`;
    let graphEndpoint = `https://graph.microsoft.com/v1.0/me/onlineMeetings`;
    const requestBody = {
      startDateTime: this.state.meeting_start_date,
      endDateTime: this.state.meeting_end_date,
      subject: this.state.meeting_name,
      participants: {
        attendees: [
          {
            identity: {
              user: {
                id: this.state.user.id,
                displayName: name,
              },
            },
            upn: this.state.user.mail,
          },
        ],
      },
    };
    let graphRequestParams = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "bearer " + this.state.graphAccessToken, //create meeting on service account is in beta
      },
      body: JSON.stringify(requestBody),
    };
    let response = await fetch(graphEndpoint, graphRequestParams).catch(
      this.unhandledFetchError
    );
    let data = await response.json().catch(this.unhandledFetchError);
    this.setState({
      meeting: false,
      event: false,
    });

    this.setState({
      meetingUrl: data["joinWebUrl"],
    });
    console.log("RESPONSE");
    console.log(response);
    console.log("DATA");
    console.log(data);
    console.log("meetingUrl");
    console.log(data["joinWebUrl"]);
    let webURL = data["joinWebUrl"];
    //alert("Before Redirect => ");
    microsoftTeams.executeDeepLink(webURL);
  };

  createTeamEvent = async () => {
    console.log("Call User");
    console.log(this.state.user);
    let mail = this.state.user.mail;
    let topic = this.state.meeting_name;
    let start_date = this.state.meeting_start_date + "T12:00:00";
    let end_date = this.state.meeting_end_date + "T12:00:00";

    //let name = user.displayName;
    //microsoftTeams.executeDeepLink("https://teams.microsoft.com/l/chat/0/0?users=joe@contoso.com,bob@contoso.com&topicName=Prep%20For%20Meeting%20Tomorrow&message=Hi%20folks%2C%20kicking%20off%20a%20chat%20about%20our%20meeting%20tomorrow");
    //let link = "https://teams.microsoft.com/l/chat/0/0?users=" + mail + "&topicName=Prep%20For%20Meeting%20Tomorrow&message=Hi%" + name + "%2C%20kicking%20off%20a%20chat%20about%20our%20meeting%now";
    let link =
      "https://teams.microsoft.com/l/meeting/new?subject=" +
      topic +
      "&attendees=" +
      mail +
      "&startTime=" +
      start_date +
      "&endTime=" +
      end_date +
      "&content=" +
      topic;
    console.log(link);
    microsoftTeams.executeDeepLink(link);
    //alert(mail)
  };

  createEvent = async () => {
    let upn = this.state.context["upn"];

    var name = this.state.user.displayName;

    let calenderEndpoint = "https://graph.microsoft.com/v1.0/me/calendars";
    const requestParams = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "bearer " + this.state.graphAccessToken,
      },
    };

    let tresponse = await fetch(calenderEndpoint, requestParams).catch(
      this.unhandledFetchError
    );
    let tdata = await tresponse.json().catch(this.unhandledFetchError);
    this.setState({
      calendarData: tdata["value"][0],
    });
    console.log(tdata["value"][0]);
    console.log(tresponse);

    let calenderlistEndpoint =
      "https://graph.microsoft.com/v1.0/users/" + upn + "/calendar/events";
    const crequestParams = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "bearer " + this.state.graphAccessToken,
      },
    };

    let cresponse = await fetch(calenderlistEndpoint, crequestParams).catch(
      this.unhandledFetchError
    );
    let cdata = await cresponse.json().catch(this.unhandledFetchError);
    console.log(cdata);
    console.log(cresponse);

    const min = 1;
    const max = 100;
    const rand = min + Math.random() * (max - min);

    //alert(this.state.user.mail);
    //alert(this.state.user_to_meet);

    let graphEndpoint = `https://graph.microsoft.com/v1.0/users/${this.state.user_to_meet}/calendar/events`;
    //let graphEndpoint = `https://graph.microsoft.com/v1.0/users/me/calendar/events`;
    //let graphEndpoint = `https://graph.microsoft.com/v1.0/me/calendar/events`;
    const requestBody = {
      subject: this.state.meeting_name,
      body: {
        contentType: "HTML",
        content: this.state.meeting_name,
      },
      start: {
        dateTime: this.state.meeting_start_date + "T00:00:00",
        timezone: "Asia/Kolkata",
      },
      end: {
        datetime: this.state.meeting_end_date + "T12:00:00",
        timezone: "Asia/Kolkata",
      },
      location: {
        displayName: this.state.meeting_name,
      },
      attendees: [
        {
          emailAddress: {
            address: upn,
            name: name,
          },
          type: "required",
        },
      ],
      allowNewTimeProposals: true,
      isOnlineMeeting: true,
      transactionId: this.state.user_to_meet + rand,
    };
    let graphRequestParams = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "bearer " + this.state.ServiceAccessToken,
      },
      body: JSON.stringify(requestBody),
    };
    console.log("Response ======> ");
    console.log(requestBody);
    console.log("Response ======> ");
    console.log(graphRequestParams);
    let response = await fetch(graphEndpoint, graphRequestParams).catch(
      this.unhandledFetchError
    );
    let data = await response.json().catch(this.unhandledFetchError);
    this.setState({
      meeting: false,
      event: false,
      page: 0,
    });
    console.log(data);
    console.log(response);
  };

  TriggerEvent = async (user) => {
    console.log("User Data: ");
    console.log(user);
    this.setState({
      event: true,
      meeting: true,
      page: 0,
      user: user,
      user_to_meet: user.id,
    });
  };

  render() {




    let avatar = "";

    //this.state.photo !== "" ?
    //<Avatar image={this.state.photo} size='largest' /> : null;

    let content;
    if (this.state.error) {
      content = (
        <h1>
          ERROR: Please ensure pop-ups are allowed for this website and retry
        </h1>
      );
    } else {
      content = (
        <div>
  
          {this.state.page === 1 && (
            <>
              <h2 class="w3-padding-16 w3-text-dark-grey">Create Events</h2>
              <div class="w3-row-padding">
                <div class="w3-margin-bottom">
                  {this.state.userData.length > 0 &&
                    this.state.userData.map(
                      (item) =>
                        this.state.context["upn"] !== item.mail && (
                          <>
                            <ul class="w3-ul w3-white w3-center w3-opacity w3-hover-opacity-off">
                              <li class="w3-dark-grey w3-xlarge w3-padding-32">
                                {item.displayName}, {item.jobTitle}
                              </li>
                              <li class="w3-dark-grey w3-xlarge w3-padding-32">
                                {item.mail}
                              </li>
                              <li class="w3-light-grey w3-padding-24">
                                <button
                                  class="w3-button w3-white w3-padding-large w3-hover-black"
                                  onClick={() => this.TriggerEvent(item)}
                                >
                                  Create Event
                                </button>
                                &nbsp;&nbsp;
                                <button
                                  class="w3-button w3-white w3-padding-large w3-hover-black"
                                  onClick={() => this.callUser(item)}
                                >
                                  Chat User
                                </button>
                              </li>
                            </ul>
                            <br />
                          </>
                        )
                    )}
                </div>
              </div>
            </>
          )}

          {this.state.page === 2 && (
            <>
              <h2 class="w3-padding-16 w3-text-dark-grey">
                Create Event - {this.state.user.displayName},{" "}
                {this.state.user.jobTitle}
              </h2>
              <div class="w3-row-padding">
                <div class="w3-margin-bottom">
                  <ul class="w3-ul w3-white w3-center w3-opacity w3-hover-opacity-off">
                    <li class="w3-dark-grey w3-xlarge w3-padding-32">
                      Event Name:&nbsp;&nbsp;&nbsp;
                      <input
                        type="text"
                        name="meeting_name"
                        value={this.state.meeting_name}
                        onChange={(e) =>
                          this.onMeetingNameChange(e.target.value)
                        }
                      />
                    </li>
                    <li class="w3-dark-grey w3-xlarge w3-padding-32">
                      Start Date:&nbsp;&nbsp;&nbsp;
                      <input
                        type="date"
                        name="start_date"
                        value={this.state.meeting_start_date}
                        onChange={(e) =>
                          this.onMeetingStartDate(e.target.value)
                        }
                      />
                    </li>
                    <li class="w3-dark-grey w3-xlarge w3-padding-32">
                      End Date:&nbsp;&nbsp;&nbsp;
                      <input
                        type="date"
                        name="end_date"
                        value={this.state.meeting_end_date}
                        onChange={(e) => this.onMeetingendDate(e.target.value)}
                      />
                    </li>

                    <li class="w3-light-grey w3-padding-24">
                      <button
                        class="w3-button w3-white w3-padding-large w3-hover-black"
                        onClick={() => this.createEvent()}
                      >
                        Create Event
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="w3-button w3-white w3-padding-large w3-hover-black"
                        onClick={() => this.createTeamEvent()}
                      >
                        Create Event In Group
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="w3-button w3-white w3-padding-large w3-hover-black"
                        onClick={() => this.createMeeting()}
                      >
                        Create Meeting
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          )}

        </div>
      );
    }

    return (
      <>
        {this.state.page === 0 && <HomeTag status={this.state.status} />}
        {this.state.page !== 0 && (
          <div>
            <nav className="w3-sidebar w3-bar-block w3-small w3-hide-small w3-center">
              <img
  className="logo"
  src="https://img1.wsimg.com/isteam/ip/7daf84c5-2f97-4cfe-8829-d2e745c6a901/logo-V4-b.png"
  style={{ width: "100%" }}
  alt="Company logo"
/>
              <button type="button" className="w3-bar-item w3-button w3-padding-large w3-black" onClick={this.loadHome}>
  <i className="fa fa-home w3-xxlarge"></i>
  <p>HOME</p>
</button>
              {this.state.login && (
               <button
  type="button"
  className="w3-bar-item w3-button w3-padding-large w3-hover-black"
  onClick={this.getUsers}
>
  <i className="fa fa-user w3-xxlarge"></i>
  <p>EVENT & CALL</p>
</button>
              )}
            </nav>

            <div className="w3-top w3-hide-large w3-hide-medium" id="myNavbar">
              <div className="w3-bar w3-black w3-opacity w3-hover-opacity-off w3-center w3-small">
                 <button type="button" className="w3-bar-item w3-button" style={{ width: "25%" }}>
  HOME
</button>
<button type="button" className="w3-bar-item w3-button" style={{ width: "25%" }}>
  EVENT & CALL
</button>
              </div>
            </div>

            <div className="w3-padding-large" id="main">
              <header
                class="w3-container w3-padding-32 w3-center w3-black"
                id="home"
              >
                {this.state.page === 0 && (
                  <h1 class="w3-jumbo">
                    <span class="w3-hide-small">MY</span> HOME
                  </h1>
                )}
                {this.state.page === 1 && (
                  <h1 class="w3-jumbo">
                    <span class="w3-hide-small">EVENTS</span> & CHAT
                  </h1>
                )}
                {this.state.page === 2 && (
                  <h1 class="w3-jumbo">
                    <span class="w3-hide-small">CREATE</span> EVENT
                  </h1>
                )}
                <hr />
                <small>VERSION 0.0.5</small>
                <p>
                  {Object.keys(this.state.context).length > 0
                    ? this.state.context["upn"]
                    : ""}
                </p>
                <h1 class="w3-image">{avatar}</h1>
              </header>

              {content}

              {this.state.meeting ? (
                <div>
                </div>
              ) : (
                <div>{this.state.meetingUrl}</div>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}
export default Tab;
